import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "padh20 text-left"
}
const _hoisted_2 = { class: "flex-node-col leftFilterPane" }
const _hoisted_3 = { class: "sidebar-result-count-badge" }
const _hoisted_4 = { class: "sidebar-filter-scroll-area" }
const _hoisted_5 = { class: "sidebar-search-zone" }
const _hoisted_6 = { class: "sidebar-filter-panel-content" }
const _hoisted_7 = { class: "sidebar-filter-panel-content" }
const _hoisted_8 = {
  key: 0,
  class: "sidebar-active-filters-panel"
}
const _hoisted_9 = { class: "sidebar-active-filters-header" }
const _hoisted_10 = { class: "sidebar-active-filters-title" }
const _hoisted_11 = { class: "sidebar-active-filters-content" }
const _hoisted_12 = { class: "flex-node-col rightFilterPane" }
const _hoisted_13 = { class: "flex-container-row align-center filter-state-toolbar" }
const _hoisted_14 = { class: "result-count-detail" }
const _hoisted_15 = { class: "size-slider-container" }
const _hoisted_16 = { class: "size-slider-label" }
const _hoisted_17 = {
  class: "flex-item-scroll",
  style: {"padding":"10px 0 10px 0"}
}
const _hoisted_18 = { class: "flex-container-row flex-wrap gap20 padh10" }
const _hoisted_19 = ["id", "title"]
const _hoisted_20 = {
  key: 0,
  style: {"margin":"40px"}
}
const _hoisted_21 = { class: "flex-node-col" }
const _hoisted_22 = { class: "flex-node-col" }
const _hoisted_23 = { class: "filterSection" }
const _hoisted_24 = { class: "flex-container-row align-center filterButtons" }
const _hoisted_25 = { class: "flex-container-row gap5" }
const _hoisted_26 = { class: "flex-container-row gap5 flex-item-right" }
const _hoisted_27 = { class: "flex-container-row" }
const _hoisted_28 = { class: "flex-node-col" }
const _hoisted_29 = { class: "filter-header flex-container-row" }
const _hoisted_30 = { class: "flex-item-scroll" }
const _hoisted_31 = {
  class: "flex-container-col",
  style: {"height":"100%"}
}
const _hoisted_32 = { class: "filter-header flex-container-row" }
const _hoisted_33 = { class: "flex-item-scroll" }
const _hoisted_34 = {
  class: "flex-container-col",
  style: {"height":"100%"}
}
const _hoisted_35 = { class: "filter-header flex-container-row" }
const _hoisted_36 = { style: {"flex-grow":"1","overflow":"auto"} }
const _hoisted_37 = {
  ref: "mobileResultRef",
  class: "flex-node-col",
  style: {"position":"relative"}
}
const _hoisted_38 = {
  class: "flex-container-col grid-header",
  style: {"position":"relative","z-index":"1","background":"var(--bg-default)"}
}
const _hoisted_39 = { class: "k-font-weight-bold" }
const _hoisted_40 = {
  class: "flex-item-scroll mobile-result-scroll",
  style: {"padding":"10px 0 10px 0","width":"100%","margin-top":"5px"}
}
const _hoisted_41 = ["id", "title"]
const _hoisted_42 = {
  key: 0,
  style: {"margin":"40px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_sparepart_search_filter = _resolveComponent("sparepart-search-filter")!
  const _component_sparepart_type_tree = _resolveComponent("sparepart-type-tree")!
  const _component_expansion_panel_content = _resolveComponent("expansion-panel-content")!
  const _component_reveal = _resolveComponent("reveal")!
  const _component_expansion_panel = _resolveComponent("expansion-panel")!
  const _component_sparepart_function_filter = _resolveComponent("sparepart-function-filter")!
  const _component_sparepart_filter_state = _resolveComponent("sparepart-filter-state")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_slider = _resolveComponent("slider")!
  const _component_material_link = _resolveComponent("material-link")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_scroll_arrows = _resolveComponent("scroll-arrows")!
  const _component_splitter = _resolveComponent("splitter")!
  const _component_push = _resolveComponent("push")!
  const _component_dynamic_view_switcher = _resolveComponent("dynamic-view-switcher")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, { "has-loaded": _ctx.hasLoaded }, {
    default: _withCtx(() => [
      (_ctx.dataNotAvailableYet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.localize('notAvailableYet')), 1))
        : (_openBlock(), _createBlock(_component_dynamic_view_switcher, {
            key: 1,
            threshold: 800
          }, {
            large: _withCtx(() => [
              _createVNode(_component_splitter, {
                panes: _ctx.splitterPanes,
                orientation: "horizontal",
                onChange: _ctx.onSplitterResize,
                class: "flex-node-col",
                style: {"border":"0"}
              }, {
                tree: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_card, { class: "flex-node-col" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_header, { class: "k-hstack subsection" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_my_icon, { icon: "filter" }),
                            _createVNode(_component_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localize('filter')), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.fileredMaterialsCount), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card_body, { class: "flex-node-col" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_sparepart_search_filter, { class: "sidebar-search" })
                              ]),
                              _createVNode(_component_expansion_panel, {
                                title: _ctx.typeFilterPanelTitle,
                                expanded: _ctx.typeFilterExpanded,
                                onAction: _ctx.onTypeFilterPanelAction
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_reveal, { appear: _ctx.typeFilterExpanded }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_expansion_panel_content, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_6, [
                                            _createVNode(_component_sparepart_type_tree)
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["appear"])
                                ]),
                                _: 1
                              }, 8, ["title", "expanded", "onAction"]),
                              _createVNode(_component_expansion_panel, {
                                title: _ctx.functionFilterPanelTitle,
                                expanded: _ctx.functionFilterExpanded,
                                onAction: _ctx.onFunctionFilterPanelAction
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_reveal, { appear: _ctx.functionFilterExpanded }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_expansion_panel_content, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_7, [
                                            _createVNode(_component_sparepart_function_filter, { "root-function": _ctx.functionFilterRoot }, null, 8, ["root-function"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["appear"])
                                ]),
                                _: 1
                              }, 8, ["title", "expanded", "onAction"])
                            ]),
                            (_ctx.filterIsActive)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.localize('activeFilters')), 1),
                                    _createElementVNode("span", {
                                      class: "ul-link sidebar-clear-all",
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onResetFilters && _ctx.onResetFilters(...args)))
                                    }, _toDisplayString(_ctx.localize('clearAll')), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_sparepart_filter_state)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                main: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_card, {
                      ref: "resultCardRef",
                      class: "flex-node-col result-card"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_body, { class: "flex-node-col" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.displayingXoutOfY), 1),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.localize('size')), 1),
                                _createVNode(_component_slider, {
                                  buttons: false,
                                  step: 10,
                                  min: 50,
                                  max: 400,
                                  modelValue: _ctx.cellSize,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cellSize) = $event))
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materialsToDisplay, (material) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    id: _ctx.getId(material),
                                    key: material.materialNo,
                                    title: _ctx.searchResultTitle(material),
                                    class: "filterResult flex-container-col align-center"
                                  }, [
                                    _createVNode(_component_material_link, {
                                      "material-data": material,
                                      size: _ctx.cellSize,
                                      "lazy-load": true,
                                      onClick: ($event: any) => (_ctx.redirectToMaterialView(material))
                                    }, null, 8, ["material-data", "size", "onClick"])
                                  ], 8, _hoisted_19))
                                }), 128))
                              ]),
                              (_ctx.showLoadMore)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_k_button, {
                                      icon: "aggregate-fields",
                                      onClick: _ctx.onLoadMore,
                                      class: "padh20",
                                      style: {"min-width":"50%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.localize('loadMore')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_scroll_arrows, {
                          "container-ref": _ctx.resultCardRef,
                          "scroll-selector": ".flex-item-scroll",
                          trigger: _ctx.materialsToDisplay
                        }, null, 8, ["container-ref", "trigger"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ]),
                _: 1
              }, 8, ["panes", "onChange"])
            ]),
            small: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_k_button, {
                          icon: "filter",
                          onClick: _ctx.onToggleTypeFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('type')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_k_button, {
                          icon: "filter",
                          onClick: _ctx.onToggleFunctionFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('function')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_k_button, {
                          icon: "filter",
                          onClick: _ctx.onToggleTextFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('text')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_k_button, {
                          icon: "zoom-in",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoom(-1))),
                          class: "zoom-button",
                          disabled: _ctx.cellSizeSmall == _ctx.cellSizeSmallMin
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_k_button, {
                          icon: "zoom-out",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoom(1))),
                          class: "zoom-button",
                          disabled: _ctx.cellSizeSmall == _ctx.cellSizeSmallMax
                        }, null, 8, ["disabled"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_sparepart_filter_state)
                    ])
                  ]),
                  (_ctx.showTypeFilter)
                    ? (_openBlock(), _createBlock(_component_push, {
                        key: 0,
                        appear: _ctx.showTypeFilter,
                        class: "flex-node-col"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_my_icon, { icon: "filter" }),
                              _createElementVNode("h2", null, _toDisplayString(_ctx.localize('sparePartTypes')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_sparepart_type_tree)
                            ]),
                            _createElementVNode("div", {
                              class: "filterApply",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onToggleTypeFilter && _ctx.onToggleTypeFilter(...args)))
                            }, _toDisplayString(_ctx.localize('apply')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["appear"]))
                    : _createCommentVNode("", true),
                  (_ctx.showFunctionFilter)
                    ? (_openBlock(), _createBlock(_component_push, {
                        key: 1,
                        appear: _ctx.showFunctionFilter,
                        class: "flex-node-col"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_my_icon, { icon: "filter" }),
                              _createElementVNode("h2", null, _toDisplayString(_ctx.localize('sparePartFunctions')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_sparepart_function_filter, { "root-function": _ctx.functionFilterRoot }, null, 8, ["root-function"])
                            ]),
                            _createElementVNode("div", {
                              class: "filterApply",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onToggleFunctionFilter && _ctx.onToggleFunctionFilter(...args)))
                            }, _toDisplayString(_ctx.localize('apply')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["appear"]))
                    : _createCommentVNode("", true),
                  (_ctx.showTextFilter)
                    ? (_openBlock(), _createBlock(_component_push, {
                        key: 2,
                        appear: _ctx.showTextFilter,
                        class: "flex-node-col"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_my_icon, { icon: "filter" }),
                              _createElementVNode("h2", null, _toDisplayString(_ctx.localize('textFilter')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_sparepart_search_filter, {
                                onOnChange: _ctx.onSearchFilterChanged,
                                class: "text-filter-input"
                              }, null, 8, ["onOnChange"])
                            ]),
                            _createElementVNode("div", {
                              class: "filterApply",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onToggleTextFilter && _ctx.onToggleTextFilter(...args)))
                            }, _toDisplayString(_ctx.localize('apply')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["appear"]))
                    : _createCommentVNode("", true),
                  (_ctx.showResultGrid)
                    ? (_openBlock(), _createBlock(_component_push, {
                        key: 3,
                        appear: _ctx.showResultGrid,
                        class: "flex-node-col"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.resultTitle), 1),
                              _createElementVNode("div", null, "(" + _toDisplayString(_ctx.displayingXoutOfY) + ")", 1)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["result-grid-container", `grid-col-${_ctx.cellSizeSmall}`])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materialsToDisplay, (material) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    id: _ctx.getId(material),
                                    key: material.materialNo,
                                    title: _ctx.searchResultTitle(material),
                                    class: "filterResult"
                                  }, [
                                    _createVNode(_component_material_link, {
                                      "material-data": material,
                                      fill: true,
                                      "lazy-load": true,
                                      onClick: ($event: any) => (_ctx.redirectToMaterialView(material))
                                    }, null, 8, ["material-data", "onClick"])
                                  ], 8, _hoisted_41))
                                }), 128))
                              ], 2),
                              (_ctx.showLoadMore)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createVNode(_component_k_button, {
                                      icon: "aggregate-fields",
                                      onClick: _ctx.onLoadMore,
                                      class: "padh20",
                                      style: {"min-width":"50%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.localize('loadMore')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_scroll_arrows, {
                              "container-ref": _ctx.mobileResultRef,
                              "scroll-selector": ".mobile-result-scroll",
                              trigger: _ctx.materialsToDisplay
                            }, null, 8, ["container-ref", "trigger"])
                          ], 512)
                        ]),
                        _: 1
                      }, 8, ["appear"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["has-loaded"]))
}